import { render, staticRenderFns } from "./SMAZgbTeamMembersList.vue?vue&type=template&id=fc2ae534"
import script from "./SMAZgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./SMAZgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./SMAZgbTeamMembersList.vue?vue&type=style&index=0&id=fc2ae534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports